import { render, staticRenderFns } from "./PendingRequestsTable.vue?vue&type=template&id=30ff630a&scoped=true&"
import script from "./PendingRequestsTable.vue?vue&type=script&lang=js&"
export * from "./PendingRequestsTable.vue?vue&type=script&lang=js&"
import style0 from "./PendingRequestsTable.vue?vue&type=style&index=0&id=30ff630a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff630a",
  null
  
)

export default component.exports